import { render, staticRenderFns } from "./BusinessEnquiry.vue?vue&type=template&id=42adb586&"
import script from "./BusinessEnquiry.vue?vue&type=script&lang=js&"
export * from "./BusinessEnquiry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports